module.exports = __webpack_public_path__ + "img/fiat_thumbnail.98c5f945.png";